import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material';
import { asyncScheduler, fromEvent, Subscription } from 'rxjs';
import { throttleTime } from 'rxjs/operators';
import Utils from '../../../core/shared/utils';
import * as Models from '../../models';
import { SOTBasketProductViewModel, SOTProductExtraGroupViewModel, SOTProductTagViewModel, SOTProductViewModel } from '../../models';
import { SOTService } from '../../services';
import { ActivatedRoute, Router } from "@angular/router"; import { BaseUnit } from '../../../core/shared/models';
import { ISOTProductViewModel } from '../../models/product.facade';

@Component({
  selector: "sot-product",
  templateUrl: "./product.component.html",
  styleUrls: ["./product.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductComponent implements OnInit, AfterViewInit, OnDestroy {
  /** artikel container zum scrollen */
  // @ViewChild("product_list") product_list_div: ElementRef;
  @ViewChild("basket_product_list") basket_product_list_div: ElementRef;
  @ViewChild("stepper") stepper: MatStepper;

  /** callback der aufgerufen wird, wenn die bearbeitung abgeschloßen wird */
  private _callback: () => void;
  public product: Models.SOTProductViewModel;
  public recipeLink: ISOTProductViewModel = null;
  public SOTProductTagViewModel: SOTProductTagViewModel[];
  public selectedTagFilter: number[];
  public isItemTagEnabled: boolean = false;
  public isModeOne: boolean = false;
  public isModeTwo: boolean = false;

  private _edit_product: Models.SOTBasketProductEditViewModel;
  /** ist im bearbeitungs modus geöffnet worden */
  public get in_edit_mode(): boolean {
    return this._edit_product != null;
  }

  public itemgroup: Models.SOTItemGroupViewModel = null;
  public highlight_required = false;
  /** zeigt hinweis das man nach unten scrollen kann */
  public show_product_list_bottom_scroll: boolean;
  public show_basket_product_list_bottom_scroll: boolean;
  private _productScrollSubscription: Subscription;
  private _productResizeObserver: any; // ResizeObserver
  private _basketProductScrollSubscription: Subscription;
  private _basketProductResizeObserver: any; // ResizeObserver
  private _matStepperChangeSubscription: Subscription;

  public extraGroups: Models.SOTProductExtraGroupViewModel[];
  public tempBasket: Models.SOTBasketViewModel;
  public get tempProduct(): Models.SOTBasketProductViewModel {
    return this.tempBasket.products[0];
  }
  /** product is aus einer Rezepturverkettung */
  public get isFromRecipeLinking(): boolean {
    return this.recipeLink !== null;

  }

  private _isLastStep: boolean = false;

  public constructor(private _changeDetectorRef: ChangeDetectorRef
    , private _sotService: SOTService
    , private _router: Router) {
    console.debug("--- sot-product constructor");
    this.show_product_list_bottom_scroll = false;
    this.show_basket_product_list_bottom_scroll = false;

  }

  public ngOnInit(): void {
    const me = this;

    this.isModeOne = this._sotService.Accessabilty.useModeOne;
    this.isModeTwo = this._sotService.Accessabilty.useModeTwo;
    const navigation_state = me._sotService.GetAndClearProductComponentBuffer();
    if (navigation_state.product instanceof Models.SOTProductViewModel) {
      me._edit_product = null;
      me.itemgroup = navigation_state.itemGroup;
      me.product = navigation_state.product;
      me.recipeLink = navigation_state.recipeLink;

    } else if (navigation_state.product instanceof Models.SOTBasketProductEditViewModel) {
      me._edit_product = navigation_state.product;
      me.itemgroup = null;
      me.product = me._edit_product.view_model.model;
      me.recipeLink = null;
    } else {
      console.error(`ProductComponent ngOnInit unknown type of navigation_state.product`, navigation_state.product);
    }
    me._callback = navigation_state.callback;
    if (me.product) {
      me.getItemTagSettings();
      me.extraGroups = me.product.extraGroups;
      me.tempBasket = me._sotService.GetNewProductBasket(me.product);
      me.stampCouponFieldsBeforeMerge(navigation_state);
      me.selectedTagFilter = me._sotService.GetProductTagFilter();
      me.GetProductTagsByIds(me.product.product_tag_ids);
      me.sortExtraItemsBySelectedTag(me.extraGroups);


      // Check and log missing products for extras 
      me.product.extraGroups.forEach(extragroup => {
        extragroup.extra_items.forEach(extra => {
          if (!extra.product) {
            console.error(`Missing Product for Extra [ProductID=${extra.product_id}] "${extra.title}"`);
          }

        });
      });

      // Prefill Infos when editing a product
      if (me._edit_product) {
        me.tempProduct.count = me._edit_product.count;
        me._edit_product.extra_groups.forEach(extragroup => {
          extragroup.extras.forEach(extra => {
            for (let i = 0; i < extra.count; i++) {
              me.tempProduct.addExtraGroup(extragroup.query, extra.extra_id, extra.sub_extra_id);
            }
          });
        });
      }

      // Prefill Single Option Extragroups
      me.product.extraGroups.forEach(extragroup => {
        if (extragroup.hasNoChoice && extragroup.extra_items.length > 0) {
          const extra = extragroup.extra_items[0];
          const subextra = (extra.without_subitem && !extra.with_one_subitem) ? null : extra.sub_items[0];
          me.setExtraCountTo(extragroup.max_choices, extragroup, extra, subextra);
        }
      });
    }
    me.PushChanges();
  }

  /** Stamps coupon_id/coupon_code/redemption_id on the fresh basket item before merge() or replaceProduct() runs.
   *  In edit mode the fields come from the edited basket line, so the coupon identity survives replaceProduct(). */
  private stampCouponFieldsBeforeMerge(navigation_state: { couponId?: string; couponCode?: string; redemptionId?: string }): void {
    const me = this;
    if (!me.tempProduct) {
      return;
    }
    if (me._edit_product) {
      const editedLine = me._edit_product.view_model;
      if (editedLine.isCouponItem) {
        me.tempProduct.coupon_id = editedLine.coupon_id;
        me.tempProduct.coupon_code = editedLine.coupon_code;
        me.tempProduct.redemption_id = editedLine.redemption_id;
      }
    } else if (navigation_state.couponId) {
      me.tempProduct.coupon_id = navigation_state.couponId;
      me.tempProduct.coupon_code = navigation_state.couponCode;
      me.tempProduct.redemption_id = navigation_state.redemptionId;
    }
  }

  public ngAfterViewInit(): void {
    console.debug("--- sot-product ngAfterViewInit")
    const me = this;

    // after view init, da dann die höhe bekannt ist
    const basket_product_list_el = me.basket_product_list_div.nativeElement;
    if (basket_product_list_el.scrollHeight > basket_product_list_el.offsetHeight) {
      me.show_basket_product_list_bottom_scroll = true; // show bottom scroll initial
      me.PushChanges();
    }
    const checkBasketProductListScroll = () => {
      // toggles show_basket_product_list_bottom_scroll when scrolled to the bottom or not
      const at_bottom = (basket_product_list_el.scrollTop + basket_product_list_el.offsetHeight) >= (basket_product_list_el.scrollHeight - 5 /*5=bottom_offset*/);
      if (at_bottom === me.show_basket_product_list_bottom_scroll) {
        me.show_basket_product_list_bottom_scroll = !at_bottom;
        me.PushChanges();
      }
    };
    // immer binden, da der content dynamisch ist
    // Subscribe to a throttled scrollEvent from BasketProductList
    me._basketProductScrollSubscription = fromEvent(me.basket_product_list_div.nativeElement, "scroll").pipe(
      throttleTime(50, asyncScheduler, { leading: true, trailing: true }),
    ).subscribe(() => {
      checkBasketProductListScroll();
    });

    // start observing for resize basket_product_list_el
    me._basketProductResizeObserver = new (window as any).ResizeObserver(() => { checkBasketProductListScroll(); });
    me._basketProductResizeObserver.observe(basket_product_list_el);
    me.checkIsLastStep();
  }

  public get visibleExtragroups(): SOTProductExtraGroupViewModel[] {
    return this.extraGroups.filter(extragroup => !extragroup.hasNoChoice);
  }

  public get hasExtras(): boolean {
    return this.visibleExtragroups.length > 0; // Check if there are any visible extra groups
  }

  // returns baseprice plus the price of all prefilled NoChoice Extras since we hide their price
  public getBasketProductShownBasePrice(basketProduct: SOTBasketProductViewModel) {
    const me = this;
    const sumOfPrefilledExtras = basketProduct.extra_groups.filter(eg => eg.model.hasNoChoice).reduce((a, b) => a + b.priceSum, 0);
    if (me._sotService.isMenuConceptViewActive()) {
      return basketProduct.menuPrice + sumOfPrefilledExtras;
    } else {
      return basketProduct.basePrice + sumOfPrefilledExtras;
    }
  }

  // format price base on language
  public priceFormatter(price: number): string {
    const me = this;
    return me._sotService.formatCurrency(price);
  }
  /** has product baseunit*/
  public get hasBaseUnit(): boolean {
    const me = this;
    return me.itemBaseUnit !== BaseUnit.NONE;
  }

  /** get id of itemBaseUnit */
  public get itemBaseUnit(): BaseUnit {
    const me = this;
    return me.product.details.item_Base_Unit;
  }

  /** Product price per unit */
  public get pricePerUnit(): string {
    const me = this;
    const pricePerUnit = Utils.pricePerUnit(me.product.priceWithExtras, me.product.details.item_Base_Factor);
    return me.priceFormatter(pricePerUnit);
  }

  private _baseUnit = BaseUnit;
  /**baseUnit */
  public get baseUnit() {
    const me = this;
    return me._baseUnit;
  }

  /**Alcohol content */
  public get product_alcoholContent(): string {
    const me = this;
    return me.product.details.alcohol_Content.toString();
  }

  /** Caffeine content */
  public get product_caffeineContent(): string {
    const me = this;
    return me.product.details.caffeine_Content.toString();
  }

  /** use e-commerce */
  public get use_eCommerce(): boolean {
    const me = this;
    return me._sotService.GetSettings().use_eCommerce;
  }

  /** langkey, ob pfand incl. oder zzgl. */
  public get deposit_langkey(): string {
    return this._sotService.deposit_view ? "details_incl_deposit" : "details_plus_deposit";
  }

  /** gets get item price for extra in the view */
  public itemViewPrice(extraGroup: Models.SOTProductExtraGroupViewModel, extra: Models.SOTProductExtraItemViewModel): number {
    const me = this;
    if (me._sotService.isMenuConceptViewActive()) {
      // for menu concept, we need to reduce view price by min force price in group
      return extra.price - me.product.calcMenuMinForcePrice(extraGroup);
    } else {
      return extra.price;
    }
  }

  public extraBaseUnit(extraItem: Models.SOTProductViewModel): BaseUnit {
    return extraItem.details.item_Base_Unit;
  }

  /** gets the view base price per unit */
  public extraBasePricePerUnit(extraGroup: Models.SOTProductExtraGroupViewModel, extraItem: Models.SOTProductExtraItemViewModel): string {
    const me = this;
    if (me._sotService.isMenuConceptViewActive()) {
      const pricePerUnit = Utils.pricePerUnit(extraItem.product.priceWithExtras, extraItem.product.details.item_Base_Factor);
      return me.priceFormatter(pricePerUnit - me.product.calcMenuMinForcePrice(extraGroup)) + "/1";
    } else {
      const pricePerUnit = Utils.pricePerUnit(extraItem.product.priceWithExtras, extraItem.product.details.item_Base_Factor);
      return me.priceFormatter(pricePerUnit) + "/1";
    }
  }

  /** Determines if the base price should be displayed */
  public showBasePrice(extraGroup: Models.SOTProductExtraGroupViewModel, extraItem: Models.SOTProductExtraItemViewModel): boolean {
    try {
      const baseUnit = extraItem.product.details.item_Base_Unit;
      // No base price if the unit is set to None
      if (baseUnit === BaseUnit.NONE) {
        return false;
      }
      const itemBaseFactor = extraItem.product.details.item_Base_Factor;
      // No base price if the unit is 1, e.g., 1 liter (no recalculation required by the customer)
      if (itemBaseFactor === 1) {
        return false;
      }
      let basePrice = extraItem.price;
      if (this._sotService.isMenuConceptViewActive()) {
        basePrice = basePrice - this.product.calcMenuMinForcePrice(extraGroup);
      }
      // No base price if the price is 0.00 €
      if (basePrice <= 0) {
        return false;
      }
      // Show base price if the itemBaseFactor is e.g. 250 gr., 0.75 l
      return true;
    } catch (e) {
      this._sotService.coreLogService.error("ProductComponent.showBasePrice", "catch", e);
      return false
    }
  }

  public ngOnDestroy(): void {
    console.debug("--- sot-article ngOnDestroy")
    if (this._productScrollSubscription) {
      this._productScrollSubscription.unsubscribe();
    }
    if (this._basketProductScrollSubscription) {
      this._basketProductScrollSubscription.unsubscribe();
    }
    if (this._basketProductResizeObserver) {
      this._basketProductResizeObserver.unobserve(this.basket_product_list_div.nativeElement);
    }
    if (this._matStepperChangeSubscription) {
      this._matStepperChangeSubscription.unsubscribe();
    }
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._sotService.coreLogService.error("ProductComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  public back(): void {
    const me = this;

    if (me.recipeLink) {
      me._sotService.OpenProduct(me.recipeLink, me.itemgroup, null, me._callback);
      me._sotService.shouldOpenProduct = false;
      setTimeout(() => {
        me._sotService.shouldOpenProduct = true;
      }, 1000);
    } else {
      me._callback();
    }

    me._sotService.setDefaultResetTagFilterEmpty();

    if (me._sotService.shouldNavigateToMenu) {
      me._router.navigate(['/sot/menu']);
      me._sotService.shouldNavigateToMenu = false;
    }
  }

  public get hasTagSelected(): boolean {
    const me = this;
    return me._sotService.GetProductTagFilter().length > 0;
  }

  /** item tag is enabled */
  public async getItemTagSettings() {
    const me = this;
    await me._sotService.getWebshopSettingsDataModel().then((webshopSettings) => {
      if (webshopSettings) {
        me.isItemTagEnabled = webshopSettings.is_itemtag_sot_enabled;
        me.PushChanges();
      }
    });
  }

  /** get product tags */
  public GetProductTagsByIds(tagIds: number[]) {
    const me = this;
    if (me.hasTagSelected) {
      me.SOTProductTagViewModel = me._sotService.GetProductTagsByIds(tagIds).sort((a, b) =>
        me._sotService.displaySelectedTagFirst(a.id, b.id)).slice(0, 5)
    } else {
      me.SOTProductTagViewModel = me._sotService.GetProductTagsByIds(tagIds).slice(0, 5);
    }
    return me.SOTProductTagViewModel;
  }

  /** product recomendation based on selected Tag filter */
  public checkRecomendationsByTagFilter() {
    const me = this;
    if (me.hasTagSelected) {
      me.itemgroup.recommendations.forEach(rec => {
        const hasSomeProductTags = (product_tag_ids: number[]): boolean => {
          return me.selectedTagFilter.every((id => product_tag_ids.indexOf(id) >= 0))
        }
        rec.products = rec.products.filter(product => hasSomeProductTags(product.product_tag_ids));
      });
      me.itemgroup.recommendations = me.itemgroup.recommendations.filter(itemgroup => itemgroup.products.length > 0);
      return me.itemgroup;
    }
  }

  public GetExtraProductTagsByIds(tagIds: number[]) {
    const me = this;
    let extraTags: SOTProductTagViewModel[];
    if (me.hasTagSelected) {
      extraTags = me._sotService.GetProductTagsByIds(tagIds).sort((a, b) =>
        me._sotService.displaySelectedTagFirst(a.id, b.id)).splice(0, 5);
    } else {
      extraTags = me._sotService.GetProductTagsByIds(tagIds).splice(0, 5);
    }
    return extraTags;
  }

  public hasExtraSomeProductTags(product_tag_ids: number[]): boolean {
    const me = this;
    return me.selectedTagFilter.every((id => product_tag_ids.indexOf(id) >= 0));
  }

  public fadeOutExtraBySelectedTag(extra: Models.SOTProductExtraItemViewModel): boolean {
    const me = this;
    let fadeOutExtra: boolean = false;
    if (me.hasTagSelected && extra.product) {
      if (extra.product.product_tag_ids.length > 0) {
        if (!me.isResetTagFilterActive(extra.id)) {
          fadeOutExtra = !me.hasExtraSomeProductTags(extra.product.product_tag_ids);
        }
      }
    }
    return fadeOutExtra;
  }

  public sortExtraItemsBySelectedTag(group: Models.SOTProductExtraGroupViewModel[]) {
    const me = this;
    if (me.hasTagSelected) {
      group.forEach(item => {
        item.extra_items.sort((a, b) => {
          if (a.product.product_tag_ids.length > 0 && !me.hasExtraSomeProductTags(a.product.product_tag_ids)) {
            return 1;
          } else if (b.product.product_tag_ids.length > 0 && !me.hasExtraSomeProductTags(b.product.product_tag_ids)) {
            return -1;
          } else {
            return 0;
          }
        });
      });
    }
  }

  public openResetExtraTagFilter(extra: Models.SOTProductExtraItemViewModel) {
    const me = this;
    if (me.isExtraAvailable(extra)) {
      me._sotService.openResetExtraTagFilter().then((result) => {
        if (result) {
          me._sotService.setResetTagFilterExtraIds(extra.id);
          me.PushChanges();
        }
      });
    }
  }

  public isResetTagFilterActive(extraId: number): boolean {
    const me = this;
    return me._sotService.isResetTagFilterActive(extraId);
  }

  public showProductInfo(product: Models.SOTProductViewModel): void {
    this._sotService.OpenProductDialog(product, true, () => { });
  }

  public showExtraProductInfo(product: Models.SOTProductViewModel, extra_product_label: string, event: Event): void {
    this._sotService.OpenExtraProductInfoDialog(product, true, () => { }, extra_product_label);
    event.stopPropagation();
  }

  public showProductSubDialog(product: Models.SOTProductViewModel, extra: Models.SOTProductExtraItemViewModel, extragroup: Models.SOTProductExtraGroupViewModel): void {
    const me = this;
    me._sotService.OpenExtraProductSubDialog(me.tempProduct, product, extra, extragroup, (success) => {
      if (success) {
        me.PushChanges();
      }
    });
  }

  public showProductRecommendations(itemgroup: Models.SOTItemGroupViewModel): void {
    this._sotService.OpenProductRecommendationDialog(itemgroup, this.isItemTagEnabled, () => { });
  }

  public get extra_as_image() {
    return this._sotService.GetSettings().extra_as_image;
  }

  /** display the "i" button if the required settings are active and additional information is included
   * @param extraProduct 
   * @returns hasAdditionalInfo
   */
  public displayAdditionalInformation(extraProduct: Models.SOTProductViewModel): boolean {
    const me = this;
    const settings = me._sotService.GetSettings();

    return settings && extraProduct && extraProduct.details &&
      (me.hasCO2Information(settings, extraProduct) ||
        me.hasAdditivesInformation(settings, extraProduct) ||
        me.hasNutritionInformation(settings, extraProduct) ||
        me.hasAllergeneInformation(settings, extraProduct) ||
        me.hasECommerceInformation(settings, extraProduct));
  }

  private hasCO2Information(settings: Models.SOTSettingsViewModel, extraProduct: Models.SOTProductViewModel) {
    return settings.use_co2 && extraProduct.details.co2 > 0;
  }

  private hasAdditivesInformation(settings: Models.SOTSettingsViewModel, extraProduct: Models.SOTProductViewModel) {
    return settings.use_additives && Utils.ValidateArray(extraProduct.details.additives);
  }

  private hasNutritionInformation(settings: Models.SOTSettingsViewModel, extraProduct: Models.SOTProductViewModel) {
    return settings.use_nutrition_values && extraProduct.details.nutritions && Utils.ValidateArray(extraProduct.details.nutritions.nutritionItemViewModels);
  }

  private hasAllergeneInformation(settings: Models.SOTSettingsViewModel, extraProduct: Models.SOTProductViewModel) {
    return settings.use_allergens && Utils.ValidateArray(extraProduct.details.allergens);
  }

  private hasECommerceInformation(settings: Models.SOTSettingsViewModel, extraProduct: Models.SOTProductViewModel) {
    return settings.use_eCommerce && (Utils.IsNullOrWhiteSpace(extraProduct.details.item_Content) || extraProduct.details.hasProvider_Info);
  }

  /** For toggling Extras in an ExtraGroup with max Choice = 1 */
  private toggleExtraInSingleChoice(extragroup: Models.SOTProductExtraGroupViewModel, extra: Models.SOTProductExtraItemViewModel, sub?: Models.SOTProductExtraItemViewModel) {
    if (this.isExtraAvailable(extra, sub)) {
      if (this.getCount(extragroup, extra, sub) === 0) {
        this._removeAllExtras(extragroup);
        this.addExtra(extragroup, extra, sub);
      } else {
        // In a group with max_choices 1 this will be the only Extra if it exists
        this.removeExtra(extragroup, extra, sub);
      }
    }
    this.PushChanges();
  }

  public removeExtra(extragroup: Models.SOTProductExtraGroupViewModel, extra: Models.SOTProductExtraItemViewModel, sub?: Models.SOTProductExtraItemViewModel) {
    if (this.canRemoveExtra(extragroup, extra, sub)) {
      this.tempProduct.removeExtraGroup(extragroup.query, extra.id, sub ? sub.id : 0);
    }
  }

  public addExtra(extragroup: Models.SOTProductExtraGroupViewModel, extra: Models.SOTProductExtraItemViewModel, sub?: Models.SOTProductExtraItemViewModel) {
    if (this.canAddExtra(extragroup, extra, sub)) {
      this.tempProduct.addExtraGroup(extragroup.query, extra.id, sub ? sub.id : 0);
    }
  }

  private _removeAllExtras(extragroup: Models.SOTProductExtraGroupViewModel) {
    const basketExtraGroup = this._findBasketExtraGroup(extragroup);
    if (basketExtraGroup) {
      basketExtraGroup.extras.forEach((basketExtra) => {
        basketExtra.sub_extras.forEach((basketSubExtra) => {
          this.tempProduct.removeExtraGroup(extragroup.query, basketExtra.extra_id, basketSubExtra.extra_id);
        });
        this.tempProduct.removeExtraGroup(extragroup.query, basketExtra.extra_id);
      });
    }
  }

  public getCount(extragroup: Models.SOTProductExtraGroupViewModel, extra?: Models.SOTProductExtraItemViewModel, sub?: Models.SOTProductExtraItemViewModel) {
    const existingExtraGroup = this._findBasketExtraGroup(extragroup);
    if (extra) {
      const existingExtra = existingExtraGroup ? existingExtraGroup.extras.find(e => e.extra_id === extra.id) : null;
      if (sub) {
        const existingSub = existingExtra ? existingExtra.sub_extras.find(e => e.extra_id === sub.id) : null;
        return existingSub ? existingSub.count : 0;
      }
      return existingExtra ? existingExtra.count : 0;
    }
    return existingExtraGroup ? existingExtraGroup.extras.reduce((a, b) => a + b.count, 0) : 0;
  }

  public setExtraCountTo(count: number, extragroup: Models.SOTProductExtraGroupViewModel, extra: Models.SOTProductExtraItemViewModel, sub?: Models.SOTProductExtraItemViewModel) {
    while (this.getCount(extragroup, extra, sub) > count) {
      this.removeExtra(extragroup, extra, sub);
      this.PushChanges();

    }
    while (this.getCount(extragroup, extra, sub) < count && this.canAddExtra(extragroup, extra, sub)) {
      this.addExtra(extragroup, extra, sub);
      this.PushChanges();

    }
  }

  public canAddExtra(extragroup: Models.SOTProductExtraGroupViewModel, extra: Models.SOTProductExtraItemViewModel, sub?: Models.SOTProductExtraItemViewModel) {
    const lessThanMaximumAmountOfExtra = this.getCount(extragroup) < extragroup.max_choices;
    const isAvailable = this.isExtraAvailable(extra, sub);

    return lessThanMaximumAmountOfExtra && isAvailable;
  }

  public canRemoveExtra(extragroup: Models.SOTProductExtraGroupViewModel, extra: Models.SOTProductExtraItemViewModel, sub?: Models.SOTProductExtraItemViewModel) {
    return this.getCount(extragroup, extra, sub) > 0;
  }

  public isExtraSelected(extragroup: Models.SOTProductExtraGroupViewModel, extra: Models.SOTProductExtraItemViewModel, sub?: Models.SOTProductExtraItemViewModel) {
    return this.getCount(extragroup, extra, sub) > 0;
  }

  private _findBasketExtraGroup(extragroup: Models.SOTProductExtraGroupViewModel): Models.SOTBasketItemExtraGroupViewModel {
    return this.tempProduct.extra_groups.find(eg => eg.query === extragroup.query);
  }

  public onNextExtraGroupClick(extragroup: Models.SOTProductExtraGroupViewModel) {
    if (this.areExtraGroupRequirementsMet(extragroup)) {
      this.highlight_required = false;
      this.stepper.next();
    } else {
      this.highlight_required = true;
    }
    this.PushChanges();
  }


  public checkRequirementAndAddToBasket() {
    const me = this;
    const hasRequiredAge = this.product && this.product.model && this.product.model.ask_age && this.product.model.ask_age > 0;
    if (hasRequiredAge) {
      me._sotService.validateAgeRequirement(this.product).then((result) => {
        if (result) {
          me._addToBasket();
          me.PushChanges();
        } else {
          this.back();
        }
      })
    } else {
      this._addToBasket();
    }
  }

  private _addToBasket() {
    if (this.in_edit_mode) {
      this._sotService.GetBasket().replaceProduct(this._edit_product.view_model, this.tempProduct);
    } else {
      this._sotService.GetBasket().merge(this.tempBasket);
      this.checkRecomendationsByTagFilter();
      if (this.itemgroup && this.itemgroup.recommendations.length > 0) {
        this.showProductRecommendations(this.itemgroup);
      }
    }
    this._callback();
  }

  public onDishClick(event: Event, extragroup: Models.SOTProductExtraGroupViewModel, extra: Models.SOTProductExtraItemViewModel, sub?: Models.SOTProductExtraItemViewModel) {
    event.stopPropagation();
    if (extragroup.max_choices === 1) {
      this.toggleExtraInSingleChoice(extragroup, extra, sub);
    } else {
      this.addExtra(extragroup, extra, sub);
    }
  }

  /** Überprüft ob das Produkt hinzugefügt werden kann. (Pflichtauswahl getroffen && ist verfügbar && schedule ist aktiv) */
  public canAddProductToBasket(): boolean {
    return this.product.is_available && this.product.schedule.active && this.product.extraGroups.every((extragroup) => this.areExtraGroupRequirementsMet(extragroup)); // todo doko: this.tempBasket.is_complete oder so impementiern
  }

  /** Überprüft ob die Anforderungen einer ExtraGruppe erfüllt sind
   * TODO: Sollte in SOTBasketExtraGroupViewModel extrahiert werden
   */
  public areExtraGroupRequirementsMet(extragroup: Models.SOTProductExtraGroupViewModel): boolean {
    return !extragroup.force_mode || extragroup.max_choices === this.getCount(extragroup); // todo doko: SOTProductExtraGroupViewModel.is_complete oder so impementiern
  }

  /** gets basket view price for extra */
  public getBasketExtraPrice(extra: Models.SOTBasketItemExtraItemViewModel): number {
    const me = this;
    if (me._sotService.isMenuConceptViewActive()) {
      return extra.menuPriceSum;
    } else {
      return extra.priceSum;
    }
  }

  /** Berechnet den Preis von SubExtras
   * TODO: Momentan an der Oberfläche gehandhabt, Logik sollte in das BasketModel verschoben werden
   */
  public getBasketSubExtraPrice(sub: Models.SOTBasketItemSubExtraItemViewModel): number {
    const me = this;
    // TODO doko: Keine Möglichkeit im moment die Summe zu bekommen, da ein extra mit subextras nur die Summe der subextras returned und sich selbst nicht dazuzählt
    if (me._sotService.isMenuConceptViewActive()) {
      const extraMenuMinForcePrice = sub.parent.parent.menuMinForcePrice * sub.count;
      const extraPriceSum = sub.parent.parent.parent.model.getExtraPrices(sub.parent.extra_id).discountPrice * sub.count;
      return sub.priceSum + extraPriceSum - extraMenuMinForcePrice;
    } else {
      const extraPriceSum = sub.parent.parent.parent.model.getExtraPrices(sub.parent.extra_id).discountPrice * sub.count;
      return sub.priceSum + extraPriceSum;
    }
  }

  /** is view deposit to show */
  public showDeposit(product: Models.SOTBasketProductViewModel): boolean {
    const me = this;
    if (me._sotService.isMenuConceptViewActive()) {
      if (product.model.depositWithExtras > 0) {
        return true;
      }
      const menuDepositSumWithoutMinForce = product.extra_groups.reduce<number>((sum, group) => sum += group.menuDepositSumWithoutMinForce, 0);
      return menuDepositSumWithoutMinForce > 0;
    } else {
      return product.has_deposit;
    }
  }

  /** gets basket view deposit for basket product */
  public getBasketDeposit(product: Models.SOTBasketProductViewModel): number {
    const me = this;
    // Wenn keine Konzeptansicht eingeschaltet ist oder der Artikel keine Abfragen hat, dann den berechneten Pfand dieses Artikels zurückgeben.
    if ((!me._sotService.isMenuConceptViewActive()) || (!product.model.has_extras)) {
      return product.depositSum;
    } else {
      //const menuDepositSumWithoutMinForce = product.extra_groups.reduce<number>((sum, group) => sum += group.menuDepositSumWithoutMinForce, 0);
      //if (menuDepositSumWithoutMinForce > 0) {
      //  return product.depositSum;
      //}
      //else {
      //  return product.model.depositWithExtras;
      //}

      // Den berechneten Pfand aller ausgewählten Abfragen (product.extra_groups) addieren
      const basketDepositSum = product.extra_groups.reduce<number>((sum, group) => sum += group.depositSum, 0);
      // Alle noch nicht ausgewählten Abfragen rausfiltern.
      const notSelectedExtraGroups = product.model.extraGroups.filter(allExtraGroup => !product.extra_groups.some(basketExtraGroup => basketExtraGroup.query === allExtraGroup.query));
      // und den ganzen Min Force Pfand aller noch nicht ausgewählten Abfragen dazu addieren.
      // const notSelectedDepositMinForceSum = notSelectedExtraGroups.reduce<number>((sum, group) => sum += Math.min(...group.extra_items.map(extra => product.model.calcExtraItemMenuMinForceDeposit(extra))), 0);
      const notSelectedDepositMinForceSum = notSelectedExtraGroups.reduce<number>((sum, group) => sum += product.model.calcMenuMinForceDeposit(group), 0);
      return basketDepositSum + notSelectedDepositMinForceSum;
      //getTotalSumForView()
    }
  }

  /** Prüft ob das extra oder subextra verkauft werden können */
  public isExtraAvailable(extra: Models.SOTProductExtraItemViewModel, sub?: Models.SOTProductExtraItemViewModel): boolean {
    return this._isProductAvailable(extra.product) && (sub ? this._isProductAvailable(sub.product) : true);
  }

  /** Prüft ob das product verkauft werden können */
  private _isProductAvailable(product: SOTProductViewModel) {
    return product && product.schedule.active && product.is_available;
  }

  public formatCurrency(value: number) {
    return this._sotService.formatCurrency(value);
  }

  /** check if selected step is last 
   * mat stepper is shown if extra group length is greater than 1
   * if the product has no or only one extra _isLastStep, set to true
  */
  public checkIsLastStep() {
    const me = this;
    if (!(me.extraGroups.length <= 1) && (me.stepper && me.stepper._steps.length > 1)) {
      me._matStepperChangeSubscription = me.stepper.selectionChange.subscribe((val) => {
        me._isLastStep = (val.selectedIndex === me.stepper._steps.length - 1);
      });
    }
    else {
      me._isLastStep = true;
    }
    me.PushChanges();
  }

  /** Add product to cart Button is active if the product can be added to the cart
   * and and selected tab is equal to the last step of the MatStepper */
  public AddProductButtonStateActive(): boolean {
    const me = this;
    if (me.canAddProductToBasket() && me._isLastStep) {
      return true;
    } else {
      return false;
    }
  }
}
